module.exports = __webpack_public_path__ + "static/media/slides.5ff3eae0.png";